import React, { Component } from "react";
import Client from "./Client";
import "./Options.css";

export default class Options extends Component {
  render() {
    const clients = this.props.clients.map((client, i) => {
      return (
        <Client
          key={"client" + i + "-" + client.id}
          client={client}
          picturesPath={this.props.picturesPath}
        />
      );
    });
    return (
      <div id="options" className={this.props.active ? "active" : ""}>
        <div
          className="bg-overlay"
          onClick={() => this.props.handleOptions(false)}
        />
        <div className="content">
          <div
            className="close"
            onClick={() => this.props.handleOptions(false)}
          >
            <i className="icon-x" />
          </div>
          <div className="clients">
            <h3>
              <i className="icon-users" /> Participantes
            </h3>
            {clients && clients.length > 0 ? clients : ""}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/options/Options.js